import Vue from 'vue';
import intersectionObserver from 'intersection-observer';
import './plugins/vuetify';
import { VLazyImagePlugin } from 'v-lazy-image';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './registerServiceWorker';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Loader from './components/Loader.vue';
import store from './store/store';
import router from './router/router';
import App from './App.vue';

Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(fas);

Vue.config.productionTip = false;
Vue.component('app-loader', Loader);
Vue.use(VLazyImagePlugin);

Vue.filter('readMore', (text, length, suffix) => {
  let shortText;
  if (text.length <= length) {
    shortText = text;
  } else {
    shortText = text.substring(0, length) + suffix;
  }
  return shortText;
});

new Vue({
  intersectionObserver,
  router,
  store,
  created() {
    AOS.init({
      debounceDelay: 300,
      throttleDelay: 200,
    });

    const config = {
      apiKey: 'AIzaSyC-ipCMXvB4-zFdaEsj6fEL0y1X5IxPoOY',
      authDomain: 'vue-movie-app-6cc3d.firebaseapp.com',
      databaseURL: 'https://vue-movie-app-6cc3d.firebaseio.com',
      projectId: 'vue-movie-app-6cc3d',
      storageBucket: 'vue-movie-app-6cc3d.appspot.com',
      messagingSenderId: '141494341746',
    };

    firebase.initializeApp(config);

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.commit('OnLoginUser', user);
        this.$store.commit(
          'setUserMessage',
          'Ja servus! Du bist in deim Konto ogmaid.',
        );

        // console.log('firebase -> User: ', user);

        firebase
          .firestore()
          .collection('users')
          .doc(user.email)
          .collection('favorites')
          // .orderBy('added', 'desc')
          .onSnapshot(
            (snapshot) => {
              // console.log('firebaseSnapshot: ', snapshot);

              this.$store.commit('setFavorsList', snapshot.docs);
            },
            (error) => {
              this.$store.commit('setError', error.message);
            },
          );
      }
    });
  },
  render: h => h(App),
}).$mount('#app');
